export default __webpack_public_path__ + "static/media/12.ea79112b.mp3";